"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _ActionsRedesignOptConnector = _interopRequireDefault(require("crm_ui/profile/experiments/ActionsRedesignOptConnector"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _get = _interopRequireDefault(require("transmute/get"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _immutable = require("immutable");

var _ThreeColumnLayout = _interopRequireDefault(require("crm_ui/profile/common/components/ThreeColumnLayout"));

var _MiniProfileHighlightContainer = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/mini/MiniProfileHighlightContainer"));

var _SubjectPermissions = require("crm_ui/utils/SubjectPermissions");

var _CardsSidebarAsync = _interopRequireDefault(require("crm_ui/sidebar/CardsSidebarAsync"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _SidebarCard = _interopRequireDefault(require("crm_ui/sidebar/card/SidebarCard"));

var _HighlightHeader = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/HighlightHeader"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _CollapsibleToggleHeader = _interopRequireDefault(require("crm_ui/profile/header/CollapsibleToggleHeader"));

var _generalStore = require("general-store");

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _UserSettingsKeys = _interopRequireWildcard(require("crm_data/settings/UserSettingsKeys"));

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _logProfileRenderTiming = _interopRequireDefault(require("crm_ui/utils/logProfileRenderTiming"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _SidebarError = _interopRequireDefault(require("customer-data-sidebar/SidebarError"));

var _colors = require("HubStyleTokens/colors");

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Raven = _interopRequireDefault(require("Raven"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _PreviewHighlightContainer = _interopRequireDefault(require("crm_ui/profile/sidebar/highlight/PreviewHighlightContainer"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: ", ";\n\n  && .profile-highlight-card-section {\n    padding: 16px 0 0 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-bottom: 1px solid ", ";\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-bottom: 16px;\n\n  && {\n    @media (max-width: 1100px) {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-top: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var NAV_HEIGHT = 60;
var MINI_HIGHLIGHT_HEIGHT = 71;
var MINI_HIGHLIGHT_TRANSITION_DURATION_MILLIS = 200;
var CARDS_NAMESPACE = 'UISidebarCards';

var getSortOrderKey = function getSortOrderKey(objectType) {
  return _UserSettingsKeys.default["PROFILE_SIDEBAR_" + objectType + "_ORDER"];
};

var getRightColumnSortOrderKey = function getRightColumnSortOrderKey(objectType) {
  return _UserSettingsKeys.default["PROFILE_RIGHT_SIDEBAR_" + objectType + "_ORDER"];
};

var getLeftColumnSortOrderKey = function getLeftColumnSortOrderKey(objectType) {
  return _UserSettingsKeys.default["PROFILE_LEFT_SIDEBAR_" + objectType + "_ORDER"];
};

var Divider = _styledComponents.default.div.withConfig({
  displayName: "ProfileThreeColumn__Divider",
  componentId: "sc-14cshbv-0"
})(_templateObject(), _colors.BATTLESHIP);

var HighlightLoadingState = function HighlightLoadingState() {
  return _react.default.createElement(_UIFlex.default, {
    align: "center",
    justify: "center",
    className: "relative",
    style: {
      height: 250
    }
  }, _react.default.createElement(_UILoadingOverlay.default, {
    contextual: true
  }));
};

var ProfileHighlightContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "record-highlight" */
    'crm_ui/profile/sidebar/highlight/ProfileHighlightContainer');
  },
  LoadingComponent: HighlightLoadingState,
  ErrorComponent: (0, _AsyncComponentErrorHandler.default)('record-highlight')
});

var ProfileHighlightContainerStyling = _styledComponents.default.div.withConfig({
  displayName: "ProfileThreeColumn__ProfileHighlightContainerStyling",
  componentId: "sc-14cshbv-1"
})(_templateObject2(), _colors.BATTLESHIP);

var HighlightWrapper = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "highlight-wrapper" */
    'customer-data-sidebar/highlight/HighlightWrapper');
  },
  LoadingComponent: HighlightLoadingState,
  ErrorComponent: (0, _AsyncComponentErrorHandler.default)('highlight-wrapper')
});

var editableHighlight = function editableHighlight(props) {
  return _react.default.createElement(HighlightWrapper, null, _react.default.createElement(_PreviewHighlightContainer.default, {
    isEditable: props.isEditable,
    objectType: props.objectType,
    subjectId: props.subjectId,
    subject: props.subject
  }));
};

var HighlightCardWrapper = (0, _styledComponents.default)(_SidebarCard.default).withConfig({
  displayName: "ProfileThreeColumn__HighlightCardWrapper",
  componentId: "sc-14cshbv-2"
})(_templateObject3(), function (props) {
  return props.isMiniHighlightVisible ? "-" + MINI_HIGHLIGHT_HEIGHT + "px" : 'inherit';
});

var ProfileThreeColumn =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProfileThreeColumn, _Component);

  function ProfileThreeColumn(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProfileThreeColumn);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProfileThreeColumn).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isMiniHighlightVisible: false,
      isMiniHighlightHiding: false
    };
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.highlight = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(ProfileThreeColumn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _logProfileRenderTiming.default)();
    }
  }, {
    key: "getSortOrder",
    value: function getSortOrder(orderMap) {
      return (0, _get.default)('order', orderMap) || (0, _immutable.Map)();
    }
  }, {
    key: "handleLeftSidebarScroll",
    value: function handleLeftSidebarScroll() {
      var _this2 = this;

      var highlight = _reactDom.default.findDOMNode(this.highlight.current);

      if (!highlight) {
        _Raven.default.captureMessage('Could not get ref to record highlight');

        return;
      }

      var _highlight$getBoundin = highlight.getBoundingClientRect(),
          bottom = _highlight$getBoundin.bottom;

      var isMiniHighlightVisible = this.state.isMiniHighlightVisible;

      if (bottom <= NAV_HEIGHT && !isMiniHighlightVisible) {
        this.setState({
          isMiniHighlightVisible: true
        });
      } else if (bottom > NAV_HEIGHT && isMiniHighlightVisible) {
        this.setState({
          isMiniHighlightHiding: true
        }, function () {
          setTimeout(function () {
            return _this2.setState({
              isMiniHighlightVisible: false,
              isMiniHighlightHiding: false
            });
          }, MINI_HIGHLIGHT_TRANSITION_DURATION_MILLIS);
        });
      }
    }
  }, {
    key: "handleOrderChange",
    value: function handleOrderChange(sortOrderKey, newLayout) {
      (0, _UserSettingsActions.saveUserSetting)(sortOrderKey, (0, _immutable.Map)({
        order: newLayout.reduce(function (orderMap, cardType, index) {
          return orderMap.set(cardType, index);
        }, (0, _immutable.Map)())
      }));
    }
  }, {
    key: "renderHighlight",
    value: function renderHighlight() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          subject = _this$props.subject,
          subjectId = _this$props.subjectId;
      var isMiniHighlightVisible = this.state.isMiniHighlightVisible;

      if (!subject) {
        return null;
      }

      return _react.default.createElement(HighlightCardWrapper, {
        "data-selenium-component": "ProfileHighlightContainer",
        "data-sidebar-key": "Highlight",
        key: "highlight",
        cardSectionClassName: "profile-highlight-card-section",
        isMiniHighlightVisible: isMiniHighlightVisible
      }, _react.default.createElement(_HighlightHeader.default, {
        objectType: objectType,
        subject: subject,
        showActions: true,
        showBackButton: true,
        showDeleteAction: true
      }), _react.default.createElement(ProfileHighlightContainerStyling, null, _react.default.createElement(ProfileHighlightContainer, {
        ref: this.highlight,
        isEditable: (0, _SubjectPermissions.canEdit)(subject),
        objectType: objectType,
        subjectId: subjectId,
        subject: subject
      })));
    }
  }, {
    key: "renderMiniHighlight",
    value: function renderMiniHighlight() {
      var _this$props2 = this.props,
          objectType = _this$props2.objectType,
          subjectId = _this$props2.subjectId;
      var _this$state = this.state,
          isMiniHighlightVisible = _this$state.isMiniHighlightVisible,
          isMiniHighlightHiding = _this$state.isMiniHighlightHiding;
      return _react.default.createElement(_MiniProfileHighlightContainer.default, {
        key: "mini-highlight-container",
        objectType: objectType,
        subjectId: subjectId,
        isVisible: isMiniHighlightVisible,
        isHiding: isMiniHighlightHiding
      });
    }
  }, {
    key: "renderLeftSidebar",
    value: function renderLeftSidebar() {
      var _this$props3 = this.props,
          subject = _this$props3.subject,
          objectType = _this$props3.objectType,
          subjectId = _this$props3.subjectId,
          sidebarLayoutPrimary = _this$props3.sidebarLayoutPrimary,
          sidebarDataPrimary = _this$props3.sidebarDataPrimary;
      return _react.default.createElement(_ErrorBoundary.default, {
        ErrorComponent: _SidebarError.default,
        boundaryName: "ProfileThreeColumn_SidebarError"
      }, _react.default.createElement("aside", null, this.renderMiniHighlight(), this.renderHighlight(), _react.default.createElement(_CardsSidebarAsync.default, {
        key: "profile-sidebar-async",
        isEditable: (0, _SubjectPermissions.canEdit)(subject),
        layout: sidebarLayoutPrimary,
        namespace: CARDS_NAMESPACE + "_LEFT",
        objectType: objectType,
        subjectId: subjectId,
        cardsData: sidebarDataPrimary,
        sortOrder: this.getSortOrder(this.props.leftColumnSortOrderSetting),
        onOrderChange: this.partial(this.handleOrderChange, getLeftColumnSortOrderKey(this.props.objectType))
      }), _react.default.createElement(Divider, null)));
    }
  }, {
    key: "renderRightSidebarCards",
    value: function renderRightSidebarCards() {
      var _this$props4 = this.props,
          objectType = _this$props4.objectType,
          onCommunicatorClick = _this$props4.onCommunicatorClick,
          subjectId = _this$props4.subjectId,
          subject = _this$props4.subject,
          isRightSidebarCollapsed = _this$props4.isRightSidebarCollapsed,
          sidebarLayoutSecondary = _this$props4.sidebarLayoutSecondary;

      if (isRightSidebarCollapsed || !subject) {
        return null;
      }

      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_CardsSidebarAsync.default, {
        PreviewHighlight: editableHighlight,
        isEditable: (0, _SubjectPermissions.canEdit)(subject),
        layout: sidebarLayoutSecondary,
        namespace: CARDS_NAMESPACE + "_RIGHT",
        objectType: objectType,
        onCommunicatorClick: onCommunicatorClick,
        subjectId: subjectId,
        sortOrder: this.getSortOrder(this.props.rightColumnSortOrderSetting),
        onOrderChange: this.partial(this.handleOrderChange, getRightColumnSortOrderKey(this.props.objectType)),
        showIntegrationCards: true
      }), _react.default.createElement(Divider, null));
    }
  }, {
    key: "renderRightSidebar",
    value: function renderRightSidebar() {
      return _react.default.createElement(_ErrorBoundary.default, {
        ErrorComponent: _SidebarError.default,
        boundaryName: "ProfileThreeColumn_SidebarError"
      }, _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, _react.default.createElement(_CollapsibleToggleHeader.default, {
        objectType: this.props.objectType
      }), _react.default.createElement("div", {
        className: "width-100"
      }, this.renderRightSidebarCards())));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          overlays = _this$props5.overlays,
          objectType = _this$props5.objectType,
          subjectId = _this$props5.subjectId,
          children = _this$props5.children,
          OverlaysRightSidebar = _this$props5.OverlaysRightSidebar,
          topFullWidth = _this$props5.topFullWidth,
          subject = _this$props5.subject,
          pageHeader = _this$props5.pageHeader,
          isRightSidebarCollapsed = _this$props5.isRightSidebarCollapsed;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_ActionsRedesignOptConnector.default, null), _react.default.createElement(_ThreeColumnLayout.default, {
        leftSidebar: this.renderLeftSidebar(),
        rightSidebar: this.renderRightSidebar(),
        isRightSidebarCollapsed: isRightSidebarCollapsed,
        pageHeader: pageHeader,
        overlays: overlays,
        objectType: objectType,
        subjectId: subjectId,
        OverlaysRightSidebar: OverlaysRightSidebar,
        topFullWidth: topFullWidth,
        subject: subject,
        onLeftSidebarScroll: this.handleLeftSidebarScroll
      }, children));
    }
  }]);
  return ProfileThreeColumn;
}(_react.Component);

ProfileThreeColumn.propTypes = {
  OverlaysRightSidebar: _propTypes.default.array,
  children: _propTypes.default.node,
  isRightSidebarCollapsed: _propTypes.default.bool,
  leftColumnSortOrderSetting: _reactImmutableProptypes.default.map,
  objectType: _ProfileObjectTypesType.default,
  onCommunicatorClick: _propTypes.default.func,
  overlays: _propTypes.default.array,
  pageHeader: _propTypes.default.node,
  rightColumnSortOrderSetting: _reactImmutableProptypes.default.map,
  sidebarDataPrimary: _propTypes.default.object,
  sidebarLayoutPrimary: _propTypes.default.array,
  sidebarLayoutSecondary: _propTypes.default.array,
  subject: _SubjectType.default,
  subjectId: _propTypes.default.string,
  topFullWidth: _propTypes.default.node
};
var dependency = {
  isRightSidebarCollapsed: {
    stores: [_UserSettingsStore.default],
    deref: function deref() {
      return _UserSettingsStore.default.get(_UserSettingsKeys.HAS_COLLAPSED_RIGHT_SIDEBAR);
    }
  },
  sortOrderSetting: {
    stores: [_UserSettingsStore.default],
    deref: function deref(_ref) {
      var objectType = _ref.objectType;
      return _UserSettingsStore.default.get(getSortOrderKey(objectType));
    }
  },
  rightColumnSortOrderSetting: {
    stores: [_UserSettingsStore.default],
    deref: function deref(_ref2) {
      var objectType = _ref2.objectType;
      return _UserSettingsStore.default.get(getRightColumnSortOrderKey(objectType));
    }
  },
  leftColumnSortOrderSetting: {
    stores: [_UserSettingsStore.default],
    deref: function deref(_ref3) {
      var objectType = _ref3.objectType;
      return _UserSettingsStore.default.get(getLeftColumnSortOrderKey(objectType));
    }
  }
};

var _default = (0, _generalStore.connect)(dependency)(ProfileThreeColumn);

exports.default = _default;
module.exports = exports.default;